export const logoutEvent = new EventTarget();
export const triggerLogout = () =>
  logoutEvent.dispatchEvent(new Event("logout"));
